/**
 * @file 申请试用页面
 * @author wangzhuang
 */

import {GET_VDC_REPORT} from '../actions/ActionTypes';

export function vdcReport(state = {}, action) {
    switch (action.type) {
        case GET_VDC_REPORT:
            state = action.data;
            return state;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/fileCheck.js